// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#contact-form-title
{
    font-size: clamp(25px, 4vw, 30px);
    margin-bottom: 10px;
}

#contact-form-subtitle
{
    font-size: clamp(16px, 4vw, 24px);
}


.contact-form-group
{
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom : 30px;
}

.contact-form-label
{
    margin-bottom : 5px;
    font-size: 20px;
    color : white;
}

.contact-form-input
{
    width: 50%;
    padding: 0 10px;
    height: 40px;
    font-size: 16px;
    border: none;
    background: none;
    outline: none;
    border-bottom : 1px solid white;
    color : var(--dark-secondary-color);
    background-color: white;
}

.contact-form-message
{
    width: 80%;
    font-size: 16px;
    border: 1px solid white;
    background: none;
    outline: none;
    color : var(--dark-secondary-color);
    padding : 10px;
    margin-top : 10px;
    background-color: white;
}

#form-submit-button
{
    width: 100%;
    background-color: var(--dark-secondary-color);
    color: white;
    padding: 14px 20px;
    border-radius: 4px;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 2px;
    margin-top : 20px;
    transition: 300ms ease;
}

#form-submit-button:hover
{
    background-color: var(--accent-color);
    color: var(--dark-secondary-color);
}

::placeholder 
{
    color : var(--dark-secondary-color);
    opacity: 1; 
}

@media all and (max-width : 1250px)
{
    .contact-form-input
    {
        width : 60%;
    }
}

@media all and (max-width : 850px)
{
    .contact-form-input
    {
        width : 100%;
    }

    .contact-form-message
    {
        width : 100%;
    }
}

@media all and (max-width : 450px)
{
    .contact-form-label
    {
        font-size: 16px;
    }

    .contact-form-input
    {
        font-size : 15px;
        height: 40px;
    }

    ::placeholder 
    {
        font-size: 14px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/contact-form.css"],"names":[],"mappings":"AAAA;;IAEI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;;IAEI,iCAAiC;AACrC;;;AAGA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,mCAAmC;IACnC,cAAc;IACd,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,6CAA6C;IAC7C,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;;IAEI,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;;IAEI,mCAAmC;IACnC,UAAU;AACd;;AAEA;;IAEI;;QAEI,WAAW;IACf;AACJ;;AAEA;;IAEI;;QAEI,YAAY;IAChB;;IAEA;;QAEI,YAAY;IAChB;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;;QAEI,eAAe;IACnB;AACJ","sourcesContent":["#contact-form-title\n{\n    font-size: clamp(25px, 4vw, 30px);\n    margin-bottom: 10px;\n}\n\n#contact-form-subtitle\n{\n    font-size: clamp(16px, 4vw, 24px);\n}\n\n\n.contact-form-group\n{\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n    margin-bottom : 30px;\n}\n\n.contact-form-label\n{\n    margin-bottom : 5px;\n    font-size: 20px;\n    color : white;\n}\n\n.contact-form-input\n{\n    width: 50%;\n    padding: 0 10px;\n    height: 40px;\n    font-size: 16px;\n    border: none;\n    background: none;\n    outline: none;\n    border-bottom : 1px solid white;\n    color : var(--dark-secondary-color);\n    background-color: white;\n}\n\n.contact-form-message\n{\n    width: 80%;\n    font-size: 16px;\n    border: 1px solid white;\n    background: none;\n    outline: none;\n    color : var(--dark-secondary-color);\n    padding : 10px;\n    margin-top : 10px;\n    background-color: white;\n}\n\n#form-submit-button\n{\n    width: 100%;\n    background-color: var(--dark-secondary-color);\n    color: white;\n    padding: 14px 20px;\n    border-radius: 4px;\n    font-size: 20px;\n    font-weight: 600;\n    cursor: pointer;\n    letter-spacing: 2px;\n    margin-top : 20px;\n    transition: 300ms ease;\n}\n\n#form-submit-button:hover\n{\n    background-color: var(--accent-color);\n    color: var(--dark-secondary-color);\n}\n\n::placeholder \n{\n    color : var(--dark-secondary-color);\n    opacity: 1; \n}\n\n@media all and (max-width : 1250px)\n{\n    .contact-form-input\n    {\n        width : 60%;\n    }\n}\n\n@media all and (max-width : 850px)\n{\n    .contact-form-input\n    {\n        width : 100%;\n    }\n\n    .contact-form-message\n    {\n        width : 100%;\n    }\n}\n\n@media all and (max-width : 450px)\n{\n    .contact-form-label\n    {\n        font-size: 16px;\n    }\n\n    .contact-form-input\n    {\n        font-size : 15px;\n        height: 40px;\n    }\n\n    ::placeholder \n    {\n        font-size: 14px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
